export default "__VITE_ASSET__CTjXY6uy__"